import React from 'react';
import PropTypes from 'prop-types';

import Quantity from '../../../../library/quantity/quantity';

import './miles-per-year-input.scss';

function MilesPerYearInput(props) {
  const {
    defaultValue,
    label,
    max,
    min,
    name,
    onBlur,
    onChange,
    value,
    error
  } = props;

  return (
    <div className="miles-per-year-input" styleName="container">
      <span className="miles-per-year-input__label" styleName="label">
        {label}
      </span>
      <Quantity
        className="miles-per-year-input__quantity"
        defaultValue={defaultValue}
        error={error}
        max={max}
        min={min}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        styleName="input-field"
        unit="K"
        value={value}
      />
    </div>
  );
}

MilesPerYearInput.propTypes = {
  defaultValue: PropTypes.number.isRequired,
  error: PropTypes.object,
  label: PropTypes.string,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired
};

export default MilesPerYearInput;
